import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { arrayOf, bool, func, number, string } from "prop-types";

import { calculateCheckedAreas } from "../../../helpers/area.helper";
import NeighborhoodSelector from "../../NeighborhoodSelector";
import * as S from "./styled";

export const AREAS_QUERY = gql`
  {
    areas {
      id
      name
      level
      parent_id
      map_coordinates {
        encoded_boundary
      }
      decodedCoordinates @client
    }
  }
`;

const AreaSelectorModal = ({
  dropDownElSelector,
  initialSelectedAreasIds,
  isOpen,
  onApply,
  onClose
}) => {
  const [selectedAreaIds, setSelectedAreaIds] = useState([]);
  const { data, error, loading } = useQuery(AREAS_QUERY);

  if (error) return <p>Error :(</p>;

  const initialSelectedAreas = allAreas => {
    let areas = [];
    if (dropDownElSelector.length !== 0) {
      const areaDropdown = document.querySelectorAll(
        `${dropDownElSelector}[type=checkbox]:checked`
      );
      areas = Array.from(areaDropdown).map(dropDownArea =>
        allAreas.find(area => area.id === Number(dropDownArea.value))
      );
    } else {
      areas = initialSelectedAreasIds.map(areaId =>
        allAreas.find(area => area.id === Number(areaId))
      );
    }

    return areas
      .map(area => calculateCheckedAreas(allAreas, area))
      .reduce((acc, val) => acc.concat(val), []);
  };

  useEffect(() => {
    if (data) {
      setSelectedAreaIds(initialSelectedAreas(data.areas));
    }
  }, [data]);

  const renderModalContent = () => {
    if (loading) {
      return <S.Loading>Loading...</S.Loading>;
    }
    return (
      <NeighborhoodSelector
        allAreas={data.areas}
        selectedAreaIds={selectedAreaIds}
        setSelectedAreaIds={setSelectedAreaIds}
      />
    );
  };

  return (
    <S.Modal isOpen={isOpen} onRequestClose={onClose}>
      <S.ModalHeader>
        <S.CloseButton onClick={onClose} />
        Select Your Neighborhoods
        <S.ModalHeaderButton onClick={() => onApply(selectedAreaIds)}>
          Apply
        </S.ModalHeaderButton>
      </S.ModalHeader>
      <S.ModalContainer isLoading={loading}>
        {renderModalContent()}
      </S.ModalContainer>
    </S.Modal>
  );
};

AreaSelectorModal.propTypes = {
  isOpen: bool,
  onApply: func.isRequired,
  onClose: func.isRequired,
  dropDownElSelector: string.isRequired,
  initialSelectedAreasIds: arrayOf(number)
};

AreaSelectorModal.defaultProps = {
  isOpen: false,
  initialSelectedAreasIds: []
};

export default AreaSelectorModal;
